<template>
  <div class="home">
    <van-nav-bar
      :title="sessionStorage.PerferName"
      left-arrow
      fixed
      @click-left="$router.push('/SetMenu')"
    >
      <div slot="right">
        <van-button
          class="rightBtn"
          style="margin-right: 10px;"
          color="#1989fa"
          @click="addShow()"
        >
          {{ $t("ShopList.add") }}
        </van-button>
        <van-button
          v-if="isCheckboxesShow == 'none'"
          class="rightBtn"
          color="#ee0a24"
          @click="delShow()"
        >
          {{ $t("ShopList.delete") }}
        </van-button>
        <van-button
          v-else
          class="rightBtn"
          color="#ee0a24"
          @click="isCheckboxesShow = 'none'"
        >
          {{ $t("PackageDish.cancel") }}
        </van-button>
        <!-- <van-icon
          name="./static/img/add_staff.png"
          slot="right"
          @click="addShow()"
          size="25px"
          style="margin-right: 10px;"
        /> -->
        <!-- <van-icon
          v-if="isCheckboxesShow == 'none'"
          name="./static/img/dele_staff.png"
          slot="right"
          @click="delShow()"
          size="25px"
        />
        <van-icon
          v-else
          name="./static/img/ok.png"
          slot="right"
          @click="isCheckboxesShow = 'none'"
          size="25px"
        /> -->
      </div>
    </van-nav-bar>
    <van-cell-group>
      <van-checkbox-group v-model="perferResult">
        <div v-if="perfers.length > 0">
          <draggable
            v-model="perfers"
            handle=".dragIcon"
            chosen-class="chosen"
            force-fallback="true"
            group="people"
            @start.stop="onStart"
            @end.stop="onEnd"
            :move="onMove"
          >
            <transition-group class="transition-wrapper" name="sort">
              <div
                class="van-hairline--bottom"
                style="position:relative;"
                v-for="(perfer, index) in perfers"
                :key="perfer.id"
              >
                <van-field
                  class="name"
                  v-model="perfer.name"
                  :readonly="isCheckboxesShow == 'none' ? false : true"
                  @click="isCheckboxesShow == 'none' ? '' : toggle(index)"
                  @focus="
                    isCheckboxesShow == 'none' ? showPerferBtn(index) : ''
                  "
                  @blur="
                    isCheckboxesShow == 'none' ? hidePerferBtn(index) : '';
                    handlePerfer(index);
                  "
                  :placeholder="$t('SetPerfer.pleaseAdd')"
                >
                  <van-icon
                    v-if="isCheckboxesShow == 'none'"
                    slot="left-icon"
                    name="./static/img/drag.png"
                    class="dragIcon"
                  />
                  <van-checkbox
                    :style="{ display: isCheckboxesShow }"
                    :name="perfer.id"
                    ref="perfer_checkboxes"
                    slot="left-icon"
                  >
                    <img
                      style="width: 20px;height: 20px"
                      slot="icon"
                      slot-scope="props"
                      :src="
                        props.checked
                          ? './static/img/sele.png'
                          : './static/img/unsele.png'
                      "
                    />
                  </van-checkbox>
                </van-field>
                <van-field
                  class="price"
                  v-model="perfer.price"
                  @click="isCheckboxesShow == 'none' ? '' : toggle(index)"
                  @focus="
                    isCheckboxesShow == 'none' ? showPerferBtn(index) : ''
                  "
                  @blur="
                    isCheckboxesShow == 'none' ? hidePerferBtn(index) : '';
                    handlePerfer(index);
                  "
                  :label="$t('platform.price') + '：'"
                  :placeholder="$t('platform.inputPrice')"
                />
              </div>
            </transition-group>
          </draggable>
        </div>
      </van-checkbox-group>
    </van-cell-group>
    <div v-if="isCheckboxesShow == 'block'" style="height: 50px;"></div>
    <van-tabbar v-if="isCheckboxesShow == 'block'">
      <div style="width: 100%;height: 50px;">
        <div class="bottomBtn fl">
          <van-icon
            size="30px"
            @click="selectAll()"
            name="./static/img/all.png"
          />
        </div>
        <div class="bottomBtn fr">
          <van-icon
            size="30px"
            @click="delPerfer()"
            name="./static/img/Trash_s.png"
          />
        </div>
      </div>
    </van-tabbar>
  </div>
</template>

<script>
import draggable from "vuedraggable";
export default {
  components: {
    draggable
  },
  data() {
    return {
      perfers: [],
      newPerfer: {
        name: ""
      },
      actPerferBtn: -1,
      perferResult: [],
      isCheckboxesShow: "none",
      isAddTagShow: false,
      value: ""
    };
  },
  mounted: function() {
    this.getPerferInfo();
  },
  methods: {
    getPerferInfo() {
      this.$axios({
        method: "get",
        headers: {
          Authorization: "Bearer " + sessionStorage.token
        },
        url:
          this.$build +
          "/api/tags/" +
          sessionStorage.actShopId +
          "/index/" +
          this.$route.params.id +
          "/perfer"
      })
        .then(res => {
          console.log(res);
          if (res.data.status == 200) {
            this.perfers = res.data.data;
          } else {
            for (var item in res.data.error) {
              this.$toast({
                type: "fail",
                message: res.data.error[item]
              });
            }
          }
        })
        .catch(err => {
          this.$toast({
            type: "fail",
            message: this.$t("SetPerfer.message")
          });
        });
    },
    selectAll() {
      if (this.perferResult.length != this.perfers.length) {
        this.perferResult = [];
        for (var i = this.perfers.length - 1; i >= 0; i--) {
          this.perferResult.push(this.perfers[i].id);
        }
      } else {
        this.perferResult = [];
      }
    },
    addShow() {
      this.isCheckboxesShow = "none";
      // this.isAddTagShow=true;
      this.addPerfer();
    },
    delShow(index) {
      this.isCheckboxesShow = "block";
    },
    toggle(index) {
      this.$refs.perfer_checkboxes[index].toggle();
    },
    showPerferBtn(index) {
      this.actPerferBtn = index;
    },
    hidePerferBtn(index) {
      const vm = this;
      setTimeout(function() {
        // console.log('hideTagBtn'+index)
        if (index == vm.actPerferBtn || index == -1) {
          vm.actPerferBtn = -1;
        }
      }, 60);
    },
    addPerfer() {
      // if(this.newPerfer.name){
      this.newPerfer.name = "";
      this.$axios({
        method: "post",
        headers: {
          Authorization: "Bearer " + sessionStorage.token
        },
        url: this.$build + "/api/tags/store",
        data: {
          store_id: sessionStorage.actShopId,
          pid: this.$route.params.id,
          name: this.newPerfer.name,
          category: "perfer"
        }
      })
        .then(res => {
          console.log(res);
          if (res.data.status == 200) {
            this.$toast({
              type: "success",
              message: res.data.message
            });
            this.isAddTagShow = false;
            this.newPerfer.name = "";
            this.getPerferInfo();
          } else {
            for (var item in res.data.error) {
              this.$toast({
                type: "fail",
                message: res.data.error[item]
              });
            }
          }
        })
        .catch(err => {
          this.$toast({
            type: "fail",
            message: this.$t("SetPerfer.message")
          });
        });
      // }else{
      // 	this.$toast('请填写完整信息');
      // }
    },
    patchPerfer(index) {
      this.hidePerferBtn(-1);
      if (this.perfers[index].name) {
        this.$axios({
          method: "PATCH",
          headers: {
            Authorization: "Bearer " + sessionStorage.token
          },
          url: this.$build + "/api/tags/" + this.perfers[index].id + "/update",
          data: this.perfers[index],
          withCredentials: true,
          crossDomain: true
        })
          .then(res => {
            console.log(res);
            if (res.data.status == 200) {
              this.$toast({
                type: "success",
                message: res.data.message
              });
              this.getPerferInfo();
            } else {
              for (var item in res.data.error) {
                this.$toast({
                  type: "fail",
                  message: res.data.error[item]
                });
              }
            }
          })
          .catch(err => {
            this.$toast({
              type: "fail",
              message: this.$t("SetPerfer.message")
            });
          });
      } else {
        this.$toast(this.$t("SetPerfer.toast"));
      }
    },
    delPerfer() {
      if (this.perferResult.length > 0) {
        this.$dialog
          .confirm({
            title: this.$t("SetPerfer.del"),
            message: this.$t("SetPerfer.isDel"),
            confirmButtonColor: "#2f75f4",
            confirmButtonText: this.$t("vantText.confirm"),
            cancelButtonText: this.$t("vantText.cancel")
          })
          .then(() => {
            this.$axios({
              method: "DELETE",
              headers: {
                Authorization: "Bearer " + sessionStorage.token
              },
              url: this.$build + "/api/tags/destroy",
              data: {
                ids: JSON.stringify(this.perferResult)
              }
            })
              .then(res => {
                console.log(res);
                if (res.data.status == 200) {
                  this.$toast({
                    type: "success",
                    message: res.data.message
                  });
                  this.perferResult = [];
                  this.isCheckboxesShow = "none";
                  this.getPerferInfo();
                } else {
                  for (var item in res.data.error) {
                    this.$toast({
                      type: "fail",
                      message: res.data.error[item]
                    });
                  }
                }
              })
              .catch(err => {
                this.$toast({
                  type: "fail",
                  message: this.$t("SetPerfer.message")
                });
              });
          })
          .catch(() => {});
      } else {
        this.$toast({
          type: "fail",
          message: this.$t("SetPerfer.chooseDelCategory")
        });
      }
    },
    handlePerfer(index) {
      if (this.timer) {
        clearTimeout(this.timer);
      }
      this.timer = setTimeout(() => {
        this.patchPerfer(index);
      }, 200);
    },
    onStart(e) {
      this.drag = true;
      console.log(e, "开始");
    },
    onEnd(e) {
      this.drag = false;
      this.data = {
        id: this.startItem.id,
        ids: this.endItem.id
      };
      this.perferSort();
    },
    onMove(e, originalEvent) {
      //拖拽位置
      this.startItem = e.draggedContext.element;
      //停靠位置
      this.endItem = e.relatedContext.element;
      if (e.draggedContext.element) return false;
    },
    // 更改偏好标签顺序位置
    perferSort() {
      this.$axios({
        method: "PATCH",
        headers: {
          Authorization: "Bearer " + sessionStorage.token
        },
        url: this.$build + "/api/tags/order",
        data: this.data
      })
        .then(res => {
          console.log(res);
          if (res.data.status == 200) {
            this.getPerferInfo();
          } else {
            for (var item in res.data.error) {
              this.$toast({
                type: "fail",
                message: res.data.error[item]
              });
            }
          }
          this.$toast.clear();
        })
        .catch(err => {
          console.log(err);
          this.$toast.clear();
          this.$toast({
            type: "fail",
            message: this.$t("EditDish.message")
          });
        });
    }
  }
};
</script>
<style scoped>
/deep/ .van-nav-bar .van-icon {
  font-size: 24px;
  color: #fff;
}
/deep/ .van-field .van-icon {
  font-size: 20px;
}
/deep/ .van-field {
  display: inline-block;
}
/deep/ .van-field__label {
  display: inline-block;
  width: 3.2em;
}
/deep/ .van-cell__left-icon,
.van-cell__right-icon {
  font-size: 20px;
}
/deep/ .price .van-field__value {
  display: inline-block;
  width: 60%;
}
/deep/ .van-field__left-icon {
  display: inline-block;
  float: left;
}
/deep/ .van-field__value {
  display: inline-block;
  height: 1.625rem;
}
.rightBtn {
  position: relative;
  height: 2.1875rem;
}
.name {
  width: 40%;
}
.price {
  width: 50%;
}
.home {
  width: 100%;
  height: 100vh;
}
.tagInput {
  font-size: 14px;
  text-indent: 10px;
  width: 90%;
  height: 33px;
  line-height: 33px;
  border: 1px solid #ffc914;
  margin-left: 5%;
  border-radius: 5px;
}
.bottomBtn {
  width: 30px;
  height: 30px;
  margin: 10px 20px;
}
.sort-move {
  transition: transform 0.3s;
}
.dragIcon {
  position: relative;
  z-index: 999;
}
</style>



// WEBPACK FOOTER //
// src/Shop/SetPerfer.vue